module.exports = __webpack_public_path__ + "img/cause4Red.9851b811.png";